define(["./map"], function(map) {
  return map;
});



/*****************
 ** WEBPACK FOOTER
 ** ./components/core/vendor/lodash/collection/collect.js
 ** module id = 71
 ** module chunks = 0
 **/